import {inject} from '@angular/core'
import {ConfigService} from '../services/config.service'

export const internetbankenResolver = () => {
  const service = inject(ConfigService)
  service.onInternetBankRoute.set(true)
}

